module.exports = __webpack_public_path__ + "img/Asset 1@4x.png";